import spbOrderApi from "@/service/api/SpbOrderApi";

const getReportPoStatusFilters = async (company, dbInstance) => {
    const result = await spbOrderApi.post('/spb/reports/postatus/filters', {
        company,
        dbInstance
    });
    return result.data;
};

const getReportPoStatus = async (page, limit, search, company, dbInstance, poNumber, vendorId, sortBy, sortType) => {
    const params = {
        page,
        limit,
        search: search || '',
        company: company || null,
        dbInstance: dbInstance || null,
        poNumber: poNumber || null,
        vendorId: vendorId || null,
        sortBy,
        sort: sortType
    };

    const result = await spbOrderApi.post('/spb/reports/postatus', params);
    return result.data;
};

const getReportPoStatusLength = async (search, company, dbInstance, poNumber, vendorId) => {
    const result = await spbOrderApi.post('/spb/reports/postatus/length', {
        search: search || '',
        company: company || null,
        dbInstance: dbInstance || null,
        poNumber: poNumber || null,
        vendorId: vendorId || null
    });
    return result.data.length;
};

export {
    getReportPoStatusFilters,
    getReportPoStatus,
    getReportPoStatusLength
};
